import kitchenInstance from '../instance'

const getWaiters = () => {
	return kitchenInstance.get('/waiters')
}

export default getWaiters
